import React, { useState } from 'react';
import {
  Box,
  Container,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  Text,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useToast,
  Spinner,
  Center
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await login(formData.username, formData.password);
      toast({
        title: 'เข้าสู่ระบบสำเร็จ',
        description: 'ยินดีต้อนรับสู่ระบบจัดการเงินทุนหมุนเวียน',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      navigate('/admin');
    } catch (error) {
      setError(error.message || 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ');
      toast({
        title: 'เข้าสู่ระบบไม่สำเร็จ',
        description: error.message || 'เกิดข้อผิดพลาดในการเข้าสู่ระบบ',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      console.log('Login error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center">
      <Container maxW="md">
        <Box bg="white" p={8} rounded="lg" shadow="lg">
          <VStack spacing={6}>
            <Text fontSize="2xl" fontWeight="bold" color="blue.600">
              ระบบจัดการเงินทุนหมุนเวียน
            </Text>
            <Text fontSize="lg" color="gray.600" textAlign="center">
              เข้าสู่ระบบเพื่อจัดการข้อมูล
            </Text>

            {error && (
              <Alert status="error" rounded="md">
                <AlertIcon />
                <AlertTitle>เกิดข้อผิดพลาด!</AlertTitle>
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}

            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <VStack spacing={4}>
                <FormControl isRequired>
                  <FormLabel>ชื่อผู้ใช้</FormLabel>
                  <Input
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    placeholder="กรอกชื่อผู้ใช้"
                    size="lg"
                  />
                </FormControl>

                <FormControl isRequired>
                  <FormLabel>รหัสผ่าน</FormLabel>
                  <Input
                    name="password"
                    type="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="กรอกรหัสผ่าน"
                    size="lg"
                  />
                </FormControl>

                <Button
                  type="submit"
                  colorScheme="blue"
                  size="lg"
                  width="100%"
                  isLoading={isLoading}
                  loadingText="กำลังเข้าสู่ระบบ..."
                >
                  {isLoading ? <Spinner size="sm" /> : 'เข้าสู่ระบบ'}
                </Button>
              </VStack>
            </form>

            <Text fontSize="sm" color="gray.500" textAlign="center">
              หากมีปัญหาในการเข้าสู่ระบบ กรุณาติดต่อผู้ดูแลระบบ
            </Text>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default LoginPage;


